export default __webpack_public_path__ + "locales/lv/Ldap.json?hash=427e04349f18623cdab4ce0268c1b0ef";